var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.categories.length > 0
    ? _c(
        "ul",
        { class: _vm.ul_class, staticStyle: { display: "block" } },
        _vm._l(this.categories, function (categ) {
          return _c(
            "li",
            { staticClass: "mb-2" },
            [
              _c(
                "a",
                {
                  staticClass: "p-1",
                  class: {
                    "bg-primary": !categ.is_selected,
                    "bg-success": categ.is_selected,
                  },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.set_active(categ)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "input-group-append border-0" }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-group-text border-0",
                        class: {
                          "bg-primary": !categ.is_selected,
                          "bg-success": categ.is_selected,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-control custom-checkbox" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: categ.is_selected,
                                  expression: "categ.is_selected",
                                },
                              ],
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "checkbox",
                                id: "cat_" + categ.id,
                              },
                              domProps: {
                                checked: Array.isArray(categ.is_selected)
                                  ? _vm._i(categ.is_selected, null) > -1
                                  : categ.is_selected,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = categ.is_selected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          categ,
                                          "is_selected",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          categ,
                                          "is_selected",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(categ, "is_selected", $$c)
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", {
                              staticClass: "custom-control-label",
                              attrs: { for: "cat_" + categ.id },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-5 nav-link-text" }, [
                    _vm._v("\n\t\t\t\t\t" + _vm._s(categ.title) + "\n\t\t\t\t"),
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticClass: "dl-ref bg-primary-500" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(categ.uniq_id) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.with_default
                    ? _c(
                        "b",
                        {
                          staticClass: "collapse-sign pr-3 color-white",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.set_active_default(categ)
                            },
                          },
                        },
                        [
                          _c("div", [
                            _c("i", {
                              staticClass: "fa-star fs-xxl",
                              class: {
                                "color-white fal": !categ.is_selected_main,
                                "color-warning-800 fas": categ.is_selected_main,
                              },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              !_vm.is_over_depth
                ? _c("categ_node_template", {
                    attrs: {
                      with_default: _vm.with_default,
                      max_depth: _vm.max_depth,
                      iter_depth: _vm.iter_depth + 1,
                      categories: categ.children,
                    },
                    on: {
                      set_active: _vm.set_active,
                      set_active_default: _vm.set_active_default,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }